import router from './router'
import { getCache } from '@/utils/cache'
import { Toast } from 'vant'
router.beforeEach((to, from, next) => {
  const tenderMode = to.query.tenderMode;
  if (to.meta.requiresAuth && !sessionStorage.getItem('isAuthorized_'+to.query.tenderDocumentId) 
    && (tenderMode === '0' || typeof(tenderMode) === "undefined")) {
    // 如果 tenderMode 为 0，则跳转至 /detail 路由
    if (to.path !== '/protected') {
      next({
        path: '/protected',
        query: {
          tenderDocumentId: to.query.tenderDocumentId,
          tenderDocumentTitle: to.query.tenderDocumentTitle,
          contactPerson: to.query.contactPerson,
          contactPhone: to.query.contactPhone,
        }
      })
    } else {
      next();
    }
  } else if (to.meta.auctionItemRequiresAuth && !sessionStorage.getItem('isAuthorized_auctionItem_'+to.query.auctionItemId) 
    && (tenderMode === '0' || typeof(tenderMode) === "undefined")) {
    // 如果 tenderMode 为 0，则跳转至 /detail 路由
    if (to.path !== '/auctionItem/protected') {
      next({
        path: '/auctionItem/protected',
        query: {
          auctionItemId: to.query.auctionItemId,
          auctionItemTitle: to.query.auctionItemTitle,
        }
      })
    } else {
      next();
    }
  } else if (to.meta.logisticsRequiresAuth && !sessionStorage.getItem('isAuthorized_logistics_'+to.query.tenderDocumentId) 
    && (tenderMode === '0' || typeof(tenderMode) === "undefined")) {
    // 如果 tenderMode 为 0，则跳转至 /detail 路由
    if (to.path !== '/logisticsTender/protected') {
      next({
        path: '/logisticsTender/protected',
        query: {
          tenderDocumentId: to.query.tenderDocumentId,
          tenderDocumentTitle: to.query.tenderDocumentTitle,
        }
      })
    } else {
      next();
    }
  } else {
    console.log('Navigating to:', to.path);
    console.log('user_type:', getCache('user_type'));
    console.log('system_type:', getCache('system_type'));
    // 如果是系统类型为1林业竞拍
    if(getCache('system_type') === 1){
      // 如果是林业竞拍的投标方，那么就只能进入投标相关的页面，把各系统的登录页、注册页都放开，/tendering/home和/tendering/detail主干分支上需要处理，主干分支会有账号登录
      if(getCache('user_type') === 3 || getCache('user_type') === 4){
        if(to.path.includes("/auctionItem/tendering") || to.path === '/auctionItem/protected' || to.path === '/noPermission' 
        || to.path === '/auctionItem/sysLogin' || to.path === '/auctionItem/login' 
        || to.path === '/logisticsTender/sysLogin' || to.path === '/logisticsTender/login'
        || to.path === '/logisticsTender/register' || to.path === '/auctionItem/register'
        || to.path === '/user/register' || to.path === '/user/login' || to.path === '/protected' || to.path === '/tendering/home' || to.path === '/tendering/detail'){
          next();
        } else{
          next({path: '/noPermission'});
        }
      } else {
        next();
      }
    } else if(getCache('system_type') === 2){
      // 如果是物流的投标方，那么就只能进入投标相关的页面，把各系统的登录页、注册页都放开
      if(getCache('user_type') === 3 || getCache('user_type') === 4){
        if(to.path.includes("/logisticsTender/tendering") || to.path === '/logisticsTender/protected' || to.path === '/noPermission' 
        || to.path === '/logisticsTender/sysLogin' || to.path === '/logisticsTender/login'
        || to.path === '/auctionItem/sysLogin' || to.path === '/auctionItem/login'
        || to.path === '/logisticsTender/register' || to.path === '/auctionItem/register' 
        || to.path === '/user/register' || to.path === '/user/login' || to.path === '/protected' || to.path === '/tendering/home' || to.path === '/tendering/detail'){
          next();
        } else{
          next({path: '/noPermission'});
        }
      } else {
        next();
      }
    } else {
      next();
    }
    
  }
})

  

  
// router.beforeEach((to, from, next) => {
//   var tokenStr = null
//   if (to.meta.requiresAuth && !isAuthorized()) {
//     if(to.query.tenderMode === '0' || typeof(tenderMode) === "undefined"){
//       if (to.path !== '/protected') {
//         next({
//           path: '/protected',
//           query: {
//             tenderDocumentId: to.query.tenderDocumentId,
//           }
//         })
//         tokenStr = sessionStorage.getItem('token')
//       }
//     } 
//   } else {
//     if (tokenStr !== null) {
//       next()
//     } else {
//       next({
//         path: '/protected',
//         query: {
//           tenderDocumentId: to.query.tenderDocumentId,
//         }
//       })
//     }
//   }
// });

function isAuthorized () {
  // 根据实际情况判断用户是否已经通过密码校验
  // 如果已经通过校验，则返回 true；否则返回 false
  return sessionStorage.getItem('isAuthorized');
}